const setMenuActive = (state, payload) => {
  state.menuActive = payload;
};

const setWindowWidth = (state, payload) => {
  state.window.innerWidth = payload;
};

const toggleMobileShowAvailability = (state) => {
  state.mobileShowAvailability = !state.mobileShowAvailability;
};

const setPageReady = (state, ready) => {
  state.pageReady = ready;
};

const setIdle = (state, idle) => {
  state.isIdle = idle;
};

export default {
  setMenuActive,
  setWindowWidth,
  toggleMobileShowAvailability,
  setPageReady,
  setIdle
};



// WEBPACK FOOTER //
// ./src/store/modules/ui/mutations.js